module.exports = __webpack_public_path__ + "img/icon-customer.16a81bfc.png";